import axios from 'axios';
const api = axios.create({
    baseURL:'https://us-central1-pessoais-287202.cloudfunctions.net'
});
export default api;